<template>
  <div class="setting-page">
    <div class="panel">
      <div class="title">旧账同步</div>
      <p class="tip">选择源财务系统，将历史账套数据同步至本系统。</p>
      <div class="form-row">
        <Select v-model="form.sourcePlatform" :datas="platforms" placeholder="选择源平台" style="width:200px"></Select>
        <input type="text" v-model="form.syncAccount" placeholder="同步账套名称" />
        <input type="text" v-model="form.remark" placeholder="备注" />
        <Button color="primary" @click="saveTask">保存任务</Button>
      </div>
    </div>

    <div class="panel">
      <Table :datas="datas" stripe>
        <TableItem title="源平台" prop="sourcePlatform"></TableItem>
        <TableItem title="同步账套" prop="syncAccount"></TableItem>
        <TableItem title="状态" prop="status"></TableItem>
        <TableItem title="同步时间" prop="syncTime"></TableItem>
        <TableItem title="创建时间" prop="createTime"></TableItem>
        <TableItem title="操作" :width="160">
          <template slot-scope="{ data }">
            <Button text-color="primary" size="xs" @click="startSync(data)">开始同步</Button>
            <Button text-color="red" size="xs" @click="remove(data)">删除</Button>
          </template>
        </TableItem>
      </Table>
      <Pagination v-model="pagination" @change="loadData" layout="pager" small align="center" v-if="datas.length" />
      <p v-if="!datas.length" class="empty">暂无同步任务</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SyncIndex',
  data() {
    return {
      platforms: ['柠檬云', '用友好会计', '金蝶精斗云', '金蝶账无忧', '通用导入'],
      form: { sourcePlatform: '', syncAccount: '', remark: '' },
      datas: [],
      pagination: { page: 1, size: 10, total: 0 }
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const p = { page: this.pagination.page, pageSize: this.pagination.size };
      this.$api.setting.sync.page(p).then((res) => {
        this.datas = res.data.records || [];
        this.pagination.total = res.data.total || 0;
      });
    },
    saveTask() {
      if (!this.form.sourcePlatform) {
        this.$Message.error('请选择源平台');
        return;
      }
      this.$api.setting.sync.save(this.form).then(() => {
        this.$Message.success('任务已保存');
        this.form = { sourcePlatform: '', syncAccount: '', remark: '' };
        this.loadData();
      });
    },
    startSync(row) {
      this.$api.setting.sync.startSync(row.id).then(() => {
        this.$Message.success('已开始同步，状态已更新');
        this.loadData();
      });
    },
    remove(row) {
      this.$Confirm('确认删除该同步任务？').then(() => {
        this.$api.setting.sync.delete(row.id).then(() => {
          this.$Message.success('已删除');
          this.loadData();
        });
      });
    }
  }
};
</script>

<style scoped>
.setting-page { padding: 16px; }
.panel { background: #fff; border-radius: 4px; padding: 16px; margin-bottom: 16px; }
.title { font-size: 16px; font-weight: bold; margin-bottom: 8px; }
.tip { color: #888; margin-bottom: 12px; }
.form-row { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.empty { text-align: center; color: #aaa; padding: 20px; }
</style>
